import { FC } from 'react';

interface IProps {
  title: string;
  mt?: string;
  mb?: string;
}

const PageHeader: FC<IProps> = ({ title }) => {
  return <div className={`text-[24px] mb-[20px]`}>{title}</div>;
};

export default PageHeader;
